import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const mappingsReducer = (state = {pNameAccount:{}}, action) => {
    switch (action.type) {
        case ActionTypes.ACCOUNTS_SUCCESS:

            // map pname to sourceid

            const accounts = action.response.entities && action.response.entities.account;

            const pNameAccountMap = {};

            if (accounts) {
                Object.keys(accounts).forEach((accountUid) => {
                    pNameAccountMap[accounts[accountUid].name] = '' + accounts[accountUid].uid;
                })
            }

            return Object.assign({}, state, {pNameAccount: pNameAccountMap})

        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Mappings.js
 **/